module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/8E8SyA/Images/cover.jpg?1684514755394",
      "alt": "This image is the cover for the book Spring Break at the Villa Hermes, Brandt and Donnelly Capers"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Spring Break at the Villa Hermes, Brandt and Donnelly Capers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_c('i', [_vm._v("A Brandt and Donnelly Caper: Case File Four")])])]), _c('p', [_vm._v("Troopers Ethan Brandt and Gabriel Donnelly celebrate the one-year anniversary of their engagement by flying south for a week of calm relaxation at the Villa Hermes, a gay boutique hotel on the beach. But when the rest of the guests turn out to be college guys on spring break (unwittingly booked into a gay hotel by a passive-aggressive travel agent), their week turns out to be anything but calm.")]), _vm._v(" "), _c('p', [_vm._v("Ted, one of the spring breakers, has harbored a crush on his roommate and best friend, Bark, since they met freshman year. Now, on their fourth and final spring break, Ted knows they must soon say good-bye. A lacrosse star and ladies’ man, Bark has no idea Ted has fallen for him—until a storm forces the entire group underground for twenty-four hours of stress and truth-telling. Bark doesn't want to say good-bye to Ted at graduation either. He just didn't know how to put his feelings into words or if he could face the consequences of speaking them. Brandt and Donnelly help the college guys through their crisis by showing them what love between best friends can grow into.")]), _vm._v(" "), _c('p', [_vm._v("But Ted and Bark aren’t the only spring-breakers with secrets.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Xavier Mayne\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0